import React from 'react';
import { Box, Text, Heading, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { ErrorCone } from '@components/Images/ErrorConeSvg';
import { RefreshSmall } from '@wix/wix-ui-icons-common';

type Props = {
  onClickTryAgain: () => void;
  isMobile?: boolean;
};

const BriefContactStatusModalContentFail = ({
  onClickTryAgain,
  isMobile,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Box direction="vertical" align="center" textAlign="center" padding="24px">
      <Box
        marginBottom={isMobile ? '18px' : '24px'}
        marginTop={isMobile ? '54px' : '24px'}
      >
        <ErrorCone />
      </Box>
      <Box marginBottom="18px">
        <Heading as="h3" size={isMobile ? 'extraLarge' : 'large'}>
          {t('marketplace.profile-page.contact-form.submit-fail-modal.title')}
        </Heading>
      </Box>
      <Box marginBottom="24px">
        <Text size="medium" weight="thin">
          {t(
            'marketplace.profile-page.contact-form.submit-fail-modal.subtitle',
          )}
        </Text>
      </Box>
      <Box marginBottom={isMobile ? undefined : '54px'}>
        <TextButton prefixIcon={<RefreshSmall />} onClick={onClickTryAgain}>
          {t(
            'marketplace.profile-page.contact-form.submit-fail-modal.try-again',
          )}
        </TextButton>
      </Box>
    </Box>
  );
};

export default BriefContactStatusModalContentFail;
